import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PreventDefaultModule } from '@portal-core/general/directives/prevent-default/prevent-default.module';
import { StopPropagationModule } from '@portal-core/general/directives/stop-propagation/stop-propagation.module';
import { PathDirnameModule } from '@portal-core/general/pipes/path-dir-name/path-dir-name.module';
import { CssStyleListModule } from "@portal-core/project-files/components/css-style-list.component/css-style-list.module";
import { FlareFileTextEditorGutterModule } from '@portal-core/project-files/components/flare-file-text-editor-gutter/flare-file-text-editor-gutter.module';
import { FlareFileTextEditorTagbarModule } from '@portal-core/project-files/components/flare-file-text-editor-tagbar/flare-file-text-editor-tagbar.module';
import { FlareFileTextEditorToolbarModule } from '@portal-core/project-files/components/flare-file-text-editor-toolbar/flare-file-text-editor-toolbar.module';
import { CollabFileTextEditorStatusBarModule } from '@portal-core/text-editor/components/collab-file-text-editor-status-bar/collab-file-text-editor-status-bar.module';
import { CollabFileTextEditorModule } from '@portal-core/text-editor/components/collab-file-text-editor/collab-file-text-editor.module';
import { CutCopyPasteHelpDialogModule } from '@portal-core/text-editor/components/cut-copy-paste-help-dialog/cut-copy-paste-help-dialog.module';
import { SoloFileTextEditorStatusBarModule } from '@portal-core/text-editor/components/solo-file-text-editor-status-bar/solo-file-text-editor-status-bar.module';
import { SoloFileTextEditorModule } from '@portal-core/text-editor/components/solo-file-text-editor/solo-file-text-editor.module';
import { EquationToolbarPopupPluginViewModule } from '@portal-core/text-editor/plugin-views/components/equation-toolbar-popup-plugin-view/equation-toolbar-popup-plugin-view.module';
import { NodeToolbarPopupPluginViewModule } from '@portal-core/text-editor/plugin-views/components/node-toolbar-popup-plugin-view/node-toolbar-popup-plugin-view.module';
import { SnackBarErrorModule } from '@portal-core/ui/snack-bar/components/snack-bar-error/snack-bar-error.module';
import { SnackBarWarningModule } from '@portal-core/ui/snack-bar/components/snack-bar-warning/snack-bar-warning.module';
import { FlareTextEditorComponent } from './flare-text-editor.component';

@NgModule({
  declarations: [
    FlareTextEditorComponent
  ],
  imports: [
    CollabFileTextEditorModule,
    CollabFileTextEditorStatusBarModule,
    CommonModule,
    CssStyleListModule,
    CutCopyPasteHelpDialogModule,
    FlareFileTextEditorGutterModule,
    FlareFileTextEditorTagbarModule,
    FlareFileTextEditorToolbarModule,
    MatDialogModule,
    MatDividerModule,
    MatMenuModule,
    EquationToolbarPopupPluginViewModule,
    MatSnackBarModule,
    MatTooltipModule,
    NodeToolbarPopupPluginViewModule,
    PathDirnameModule,
    PreventDefaultModule,
    ScrollingModule,
    SnackBarErrorModule,
    SnackBarWarningModule,
    SoloFileTextEditorModule,
    SoloFileTextEditorStatusBarModule,
    StopPropagationModule
  ],
  exports: [
    FlareTextEditorComponent
  ]
})
export class FlareTextEditorModule { }
